import React from 'react'
import { Toast, ToastContainer } from 'react-bootstrap'

interface ToasterProps {
    handleToggleToster: (toggle: boolean) => void;
    showToaster: boolean;
    title: string;
    content: string | React.ReactNode;
}

export const Toaster = (props: ToasterProps) => {
    const { showToaster, title, content, handleToggleToster } = props;
    return (
        <ToastContainer position="top-end" className="p-3" style={{ zIndex: 999, position: 'fixed' }}>
            <Toast onClose={() => handleToggleToster(false)} show={showToaster} delay={3000} autohide style={{ backgroundColor: '#fff'}}>
                <Toast.Body>{ content }</Toast.Body>
            </Toast>
        </ToastContainer>
    )
}
